(function () {
  document.querySelectorAll('[data-skarna-pdp]').forEach(initPDP);

  function initPDP(root) {
    var sectionId = root.dataset.sectionId;
    var form = root.querySelector('form.skr-form');
    var variantDataEl = root.querySelector('[data-skr-variant-data]');
    var variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-skr-variant-id]');
    var qtyInputs = root.querySelectorAll('[data-skr-qty]');
    var atcBtn = root.querySelector('[data-skr-atc]');
    var atcPrice = root.querySelector('[data-skr-atc-price]');
    var atcText = root.querySelector('[data-skr-atc-text]');
    var currentPrice = root.querySelector('[data-skr-current-price]');
    var comparePrice = root.querySelector('[data-skr-compare-price]');
    var saveEl = root.querySelector('[data-skr-save]');
    var stickyPrice = root.querySelector('[data-skr-sticky-price]');
    var moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    /* ----- Gallery ----- */
    var thumbs = root.querySelectorAll('[data-thumb]');
    var slides = root.querySelectorAll('[data-slide]');
    var counterEl = root.querySelector('[data-skr-counter-current]');
    var galleryWrap = root.querySelector('.skr-gallery__stage-wrap');
    var currentIdx = 0;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setSlide(parseInt(t.dataset.index, 10));
        /* The mosaic sits below the big image — scroll it back into view so the
           clicked photo is shown large, below the sticky header + tabs. */
        if (galleryWrap) {
          var hdr = document.querySelector('.section-skarna-header');
          var tabs = document.querySelector('.section-skarna-product-tabs');
          var offset = (hdr ? hdr.offsetHeight : 0) + (tabs ? tabs.offsetHeight : 0) + 16;
          var top = galleryWrap.getBoundingClientRect().top;
          if (top < offset) {
            window.scrollTo({ top: top + window.scrollY - offset, behavior: 'smooth' });
          }
        }
      });
    });
    function setSlide(i) {
      if (slides.length === 0) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      currentIdx = i;
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
        t.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      if (counterEl) counterEl.textContent = i + 1;
      /* No scrollIntoView on the active thumb here: the thumbs are a vertical mosaic
         below the image, so it would scroll the page down. Scrolling back to the big
         image is handled only on an explicit mosaic click. */
    }
    /* Prev/next nav buttons */
    root.querySelectorAll('[data-skr-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSlide(currentIdx + parseInt(btn.dataset.skrNav, 10));
      });
    });
    /* Keyboard nav */
    if (galleryWrap) {
      galleryWrap.setAttribute('tabindex', '0');
      galleryWrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); setSlide(currentIdx - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setSlide(currentIdx + 1); }
      });
      /* Touch swipe (mobile) */
      var sx = 0, sy = 0, dx = 0, dy = 0;
      galleryWrap.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; dy = 0;
      }, { passive: true });
      galleryWrap.addEventListener('touchmove', function (e) {
        var t = e.touches[0]; dx = t.clientX - sx; dy = t.clientY - sy;
      }, { passive: true });
      galleryWrap.addEventListener('touchend', function () {
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          setSlide(currentIdx + (dx < 0 ? 1 : -1));
        }
      });
    }

    /* ----- Variant selection ----- */
    function getSelectedOptions() {
      var inputs = root.querySelectorAll('[data-skr-option-input]:checked');
      if (!inputs.length) return null;
      var opts = [];
      inputs.forEach(function (i) { opts[parseInt(i.dataset.optionIndex, 10)] = i.value; });
      return opts;
    }
    function findVariant(opts) {
      if (!opts || !variants.length) return null;
      return variants.find(function (v) {
        return (v.options || []).every(function (val, idx) { return val === opts[idx]; });
      });
    }
    function setVariant(v) {
      if (!v) {
        if (atcBtn) {
          atcBtn.disabled = true;
          if (atcText) atcText.textContent = (atcBtn.dataset.unavailableLabel || 'Unavailable');
        }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (currentPrice) currentPrice.textContent = formatMoney(v.price, moneyFormat);
      if (comparePrice) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          comparePrice.textContent = formatMoney(v.compare_at_price, moneyFormat);
          comparePrice.style.display = '';
          if (saveEl) {
            saveEl.style.display = '';
            saveEl.textContent = (saveEl.dataset.prefix || 'Save') + ' ' + formatMoney(v.compare_at_price - v.price, moneyFormat);
          }
        } else {
          comparePrice.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (atcPrice) atcPrice.textContent = formatMoney(v.price, moneyFormat);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price, moneyFormat);
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcText && !v.available) atcText.textContent = atcBtn.dataset.soldOutLabel || 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-skr-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var opts = getSelectedOptions();
        setVariant(findVariant(opts));
      });
    });

    /* ----- Bundle tiers drive quantity ----- */
    root.querySelectorAll('[data-skr-tier]').forEach(function (t) {
      t.addEventListener('change', function () {
        if (t.checked) {
          var qty = parseInt(t.dataset.qty, 10) || 1;
          qtyInputs.forEach(function (q) { q.value = qty; });
        }
      });
    });

    /* ----- Quantity stepper ----- */
    var stepper = root.querySelector('[data-skr-stepper]');
    if (stepper) {
      stepper.querySelectorAll('button[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = stepper.querySelector('input');
          var step = parseInt(b.dataset.step, 10);
          var min = parseInt(input.min || '1', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || 1) + step);
        });
      });
    }

    /* ----- Subscribe (refill) toggle: optional selling-plan support ----- */
    var subInput = root.querySelector('[data-skr-subscribe-input]');
    if (subInput) {
      subInput.addEventListener('change', function () {
        var opts = getSelectedOptions();
        var v = findVariant(opts);
        if (!v || !v.selling_plan_allocations || !v.selling_plan_allocations.length) return;
        var existing = form.querySelector('input[name="selling_plan"]');
        if (subInput.checked) {
          if (!existing) {
            existing = document.createElement('input');
            existing.type = 'hidden';
            existing.name = 'selling_plan';
            form.appendChild(existing);
          }
          existing.value = v.selling_plan_allocations[0].selling_plan_id;
        } else if (existing) {
          existing.remove();
        }
      });
    }

    /* ----- Sticky mobile ATC ----- */
    var sticky = root.querySelector('[data-skr-sticky]');
    if (sticky) {
      sticky.hidden = false;
      var anchor = root.querySelector('.skr-atc');
      if (anchor && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          });
        }, { rootMargin: '0px' });
        io.observe(anchor);
      } else if (anchor) {
        sticky.classList.add('is-visible');
      }
      var stickyBtn = sticky.querySelector('[data-skr-sticky-cta]');
      if (stickyBtn && atcBtn) {
        stickyBtn.addEventListener('click', function () {
          atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { atcBtn.focus(); }, 400);
        });
      }
    }

    /* ----- AJAX add to cart (graceful fallback to normal POST) ----- */
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !atcBtn) return;
      e.preventDefault();
      atcBtn.disabled = true;
      var originalText = atcText ? atcText.textContent : '';
      if (atcText) atcText.textContent = 'Adding…';
      var fd = new FormData(form);
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && res.data.description || 'Cart error');
          document.dispatchEvent(new CustomEvent('skarna:added', { detail: res.data }));
          if (atcText) atcText.textContent = '✓ Added';
          setTimeout(function () {
            if (atcText) atcText.textContent = originalText;
            atcBtn.disabled = false;
          }, 1400);
          // Try to open theme cart drawer if it exists
          var drawer = document.querySelector('cart-drawer, [data-cart-drawer], #cart-drawer');
          if (drawer && drawer.open) drawer.open();
          else if (drawer && drawer.classList) drawer.classList.add('is-open', 'open', 'active');
          else window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
        })
        .catch(function () {
          if (atcText) atcText.textContent = originalText;
          atcBtn.disabled = false;
          form.submit();
        });
    });

    // Save label prefix from schema
    if (saveEl) saveEl.dataset.prefix = (saveEl.textContent.split(' ')[0] || 'Save');
    if (atcBtn && atcText) {
      atcBtn.dataset.unavailableLabel = 'Unavailable';
      atcBtn.dataset.soldOutLabel = atcText.textContent.trim();
    }
  }

  /* ----- Money formatting (Shopify-compatible) ----- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function defaultOption(opt, def) { return (typeof opt === 'undefined') ? def : opt; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    switch (fmt.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
})();

/* ===== Purchase options: One-time vs Subscribe ===== */
(function () {
  document.querySelectorAll('[data-skr-purchase]').forEach(function (box) {
    var form = box.closest('form');
    if (!form) return;
    var sellingPlan = form.querySelector('[data-skr-selling-plan]');
    var atc = form.querySelector('[data-skr-atc]');
    var atcPrice = form.querySelector('[data-skr-atc-price]');
    var detail = box.querySelector('[data-skr-sub-detail]');
    var note = box.querySelector('[data-skr-sub-note]');
    var hasPlans = box.getAttribute('data-has-plans') === 'true';
    var oneMoney = box.getAttribute('data-onetime-money');
    var subMoney = box.getAttribute('data-sub-money');
    var atcWasDisabled = atc ? atc.disabled : false;

    function setPrice(s) { if (atcPrice && s) atcPrice.textContent = s; }
    function selectedFreq() {
      return box.querySelector('[data-skr-freq]:checked') || box.querySelector('[data-skr-freq]');
    }
    function setActive(mode) {
      box.querySelectorAll('[data-skr-po]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-skr-po') === mode);
      });
    }
    function applyOneTime() {
      setActive('onetime');
      if (detail) detail.hidden = true;
      if (sellingPlan) sellingPlan.value = '';
      setPrice(oneMoney);
      if (atc) atc.disabled = atcWasDisabled;
    }
    function applySubscribe() {
      setActive('subscribe');
      if (detail) detail.hidden = false;
      var f = selectedFreq();
      var plan = f ? f.getAttribute('data-plan') : '';
      setPrice((f && f.getAttribute('data-money')) || subMoney);
      if (hasPlans && plan) {
        if (sellingPlan) sellingPlan.value = plan;
        if (atc) atc.disabled = atcWasDisabled;
        if (note) note.style.display = 'none';
      } else {
        if (sellingPlan) sellingPlan.value = '';
        if (atc) atc.disabled = true; /* decorative: avoid charging one-time price for a -% selection */
        if (note) note.style.display = '';
      }
    }
    function refresh() {
      var checked = box.querySelector('[data-skr-mode]:checked');
      if (checked && checked.value === 'subscribe') { applySubscribe(); } else { applyOneTime(); }
    }
    box.querySelectorAll('[data-skr-mode]').forEach(function (r) {
      r.addEventListener('change', refresh);
    });
    box.querySelectorAll('[data-skr-freq]').forEach(function (r) {
      r.addEventListener('change', function () {
        var sub = box.querySelector('[data-skr-mode="subscribe"]');
        if (sub && !sub.checked) { sub.checked = true; }
        applySubscribe();
      });
    });
    refresh();
  });
})();

/* Results before/after carousel */
(function () {
  function init(car) {
    var track = car.querySelector('[data-skr-rtrack]');
    if (!track) return;
    var prev = car.querySelector('[data-skr-rprev]');
    var next = car.querySelector('[data-skr-rnext]');
    var count = car.querySelector('[data-skr-rcount]');
    var cards = track.children;
    function gap() {
      var cs = getComputedStyle(track);
      return parseInt(cs.columnGap || cs.gap || '24', 10) || 24;
    }
    function step() { return cards.length ? cards[0].offsetWidth + gap() : 320; }
    function update() {
      if (!count || !cards.length) return;
      var i = Math.round(track.scrollLeft / step()) + 1;
      if (i < 1) i = 1; if (i > cards.length) i = cards.length;
      count.textContent = i + ' / ' + cards.length;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    update();
  }
  function boot() { document.querySelectorAll('[data-skr-results]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
